import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import RootPage from "@/pages/RootPage";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Acchiappo from "@/pages/Acchiappo";
import CookiePolicy from "@/pages/CookiePolicy";
import CookieBanner from "@/components/CookieBanner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<RootPage />} />
      <Route path="/leadders" element={<Home />} />
      <Route path="/prestito" element={<Acchiappo />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
